<template>
  <div class="custom-modal">
    <div>
      <div class="custom-modal-header">
        <div class="close-modal">
          <i class="bx bx-x" @click="closeModal"></i>
        </div>
        <div class="reload-modal">
          <i class="fas fa-sync-alt" @click="reloadClientData"></i>
        </div>
        <div class="title">
          <upload-profile-photo :data="client" :userId="clientId" :type="'client'"></upload-profile-photo>
          <h5>{{ client.firstName + ' ' + client.lastName }}</h5>
          <div class="d-flex">
            <div class="action-icon">
              <a :href="'tel:' + client.phone">
                <i class="fas fa-phone-alt"></i>
              </a>
            </div>
            <div class="action-icon">
              <a :href="'mailto:' + client.email">
                <i class="fas fa-envelope"></i>
              </a>
            </div>
            <div class="action-icon">
              <a :href="'https://admin' + webappUrl + '/suppliers/' + client.id + '/edit'" target="_blank">
                <i class="fas fa-info-circle"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-body">
        <div class="item-sales">
          <div class="modal-section">
            <div>
              <p>COMMISSIONS</p>
              <p># of commissions</p>
              <p>Total Commissions</p>
            </div>
            <div class="itemQuantity">
              <p></p>
              <p class="font-weight-bold">
                <span v-if="clientData">{{ clientData.stats.commissions[0].number }}</span>
                <span v-else class="loading-placeholder"></span>
              </p>
              <p class="font-weight-bold">
                <span v-if="clientData">{{ currency(clientData.stats.commissions[0].total) }}</span>
                <span v-else class="loading-placeholder"></span>
              </p>
            </div>
          </div>
        </div>
        <div class="item-sales">
          <div class="modal-section">
            <div>
              <p>ITEM SALES</p>
              <p># of open quotes</p>
              <p>Quotes accepted</p>
              <p>Items sold</p>
            </div>
            <div class="itemQuantity">
              <p></p>
              <p class="font-weight-bold">
                <span v-if="clientData">{{ clientData.stats.pendingItems[0]['open'] }}</span>
                <span v-else class="loading-placeholder"></span>
              </p>
              <p class="font-weight-bold">
                <template v-if="clientData">
                  {{ clientData.stats.pendingItems[0].accepted }}/{{ clientData.stats.pendingItems[0].total }}
                  <span v-if="!isNaN(this.acceptedPercentage)">({{ this.acceptedPercentage }}%)</span>
                  <span v-else>(0%)</span>
                </template>
                <span v-else class="loading-placeholder"></span>
              </p>
              <p class="font-weight-bold">
                <span v-if="clientData">{{ clientData.stats.pendingItems[0].itemsSold }}</span>
                <span v-else class="loading-placeholder"></span>
              </p>
            </div>
          </div>
          <div class="d-flex btItem">
            <a
              :href="'/quotes/pickup/' + client.id"
              class="btn btn-outline-light mr-2">
              Quotes
            </a>
          </div>
        </div>
        <div class="item-sales">
          <div class="d-flex btItem">
            <a
             :href="'https://admin.shopify.com/store/9b6844-68/customers/' + client.shopifyCustomerId"
              class="btn btn-outline-light"
            >Purchase History</a>
          </div>
        </div>
        <div class="modal-section">
          <div>
            <div class="notes-header">
              <p class="mb-0">NOTES</p>
              <processing-spinner :saving="savingComment" :saved="savedComment" />
            </div>
            <textarea
              v-model="client.comment"
              class="form-control"
              @focus="editingComment"
              @blur="updateComment"
              @input="scheduleUpdateComment"
              :placeholder="placeholder"
            ></textarea>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!clientData" class="text-center">
      <i class="fas fa-spinner fa-spin text-white"></i>
    </div>
  </div>
</template>
<script>
import api from '@/services/api'
import ProcessingSpinner from './processing-spinner'
import UploadProfilePhoto from './shared/upload-profile-photo'
export default {
  name: 'client-detail',
  components: { UploadProfilePhoto, ProcessingSpinner },
  props: ['clientId', 'clientArray'],
  data () {
    return {
      client: '',
      clientData: '',
      placeholder: this.$store.state.il8nContent['client.commentPlaceholder'],
      savedComment: false,
      savingComment: false,
      commentTimeout: null
    }
  },
  methods: {
    getClientData (force = false) {
      const cacheKey = `clientDetail_${this.clientId}`
      if (!force) {
        const cached = localStorage.getItem(cacheKey)
        if (cached) {
          const parsed = JSON.parse(cached)
          if (Date.now() - parsed.timestamp < 28800000) {
            this.clientData = parsed.data
            return
          }
        }
      }
      api
        .get('/api/stylist/clients/' + this.clientId)
        .then(response => {
          this.clientData = response.data.data.attributes
          localStorage.setItem(
            cacheKey,
            JSON.stringify({ timestamp: Date.now(), data: this.clientData })
          )
        })
    },
    reloadClientData () {
      this.clientData = ''
      this.getClientData(true)
    },
    closeModal () {
      this.$bvModal.hide('client-modal')
    },
    currency (amount) {
      return this.$helpers.currency(amount)
    },
    editingComment () {
      this.savedComment = false
    },
    scheduleUpdateComment () {
      this.savedComment = false
      clearTimeout(this.commentTimeout)
      this.commentTimeout = setTimeout(() => {
        this.updateComment()
      }, 1000)
    },
    updateComment () {
      clearTimeout(this.commentTimeout)
      this.savingComment = true
      api
        .put(
          '/api/stylist/clients/' + this.clientId,
          {
            comment: this.client.comment
          }
        )
        .then(response => {
          this.savedComment = true
          this.savingComment = false
          const updatedClient = this.clientArray.map(clientDetail => {
            if (clientDetail.id === this.client.id) {
              clientDetail.comment = this.client.comment
            }
            return clientDetail
          })
          this.$store.commit('setClients', updatedClient)
        })
    },
    goTo (url) {
      const data = {
        userId: this.clientId,
        url: process.env.VUE_APP_FASHIONPHILE_API_URL + '/' + url
      }
      this.$store.dispatch('authenticateAndRedirect', data)
    }
  },
  mounted () {
    this.client = this.$store.state.clients.find(
      client => client.id === this.clientId
    )
    this.getClientData()
  },
  computed: {
    acceptedPercentage () {
      if (!this.clientData) {
        return 0
      }
      return Number(
        (this.clientData.stats.pendingItems[0].accepted /
          this.clientData.stats.pendingItems[0].total) *
          100
      ).toFixed(0)
    },
    webappUrl () {
      return process.env.VUE_APP_FASHIONPHILE_DOMAIN || ''
    }
  }
}
</script>
<style scoped>
.d-flex {
  justify-content: center;
}
.d-flex div.action-icon {
  background: #fff;
  border-radius: 50%;
  color: #555;
  width: 30px;
  height: 30px;
  margin: 0 20px;
  font-size: 16px;
  line-height: 30px;
  text-align: center;
}

.modal-section .d-flex button {
  white-space: nowrap;
}

.notes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

textarea.form-control {
  min-height: 150px;
  background: #000 !important;
  padding: 5px;
}

textarea.form-control::placeholder {
  color: #555;
}

</style>
